module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.49.aa9accae.png";